import React from 'react';
import { Code, Server, Database, Plug } from 'lucide-react';
import { Card } from './ui/card';
import { specialties } from '../data/mock';

const iconMap = {
  code: Code,
  server: Server,
  database: Database,
  plug: Plug
};

const AboutSection = () => {
  return (
    <section id="specialties" className="py-20 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-4">
       
        <div className="text-center mb-16 space-y-4">
          <span className="text-blue-400 text-sm font-mono uppercase tracking-wider">Especialidades</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            O Que Eu Faço
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Soluções completas de desenvolvimento web, do front-end ao back-end
          </p>
        </div>

        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {specialties.map((specialty, index) => {
            const Icon = iconMap[specialty.icon];
            return (
              <Card
                key={specialty.id}
                className="bg-gray-900/50 border-gray-800 hover:border-purple-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/10 group backdrop-blur-sm"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                <div className="p-6 space-y-4">
                  
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500/20 to-purple-600/20 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Icon className="text-blue-400" size={24} />
                  </div>

                
                  <h3 className="text-xl font-semibold text-white">
                    {specialty.title}
                  </h3>

                 
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {specialty.description}
                  </p>

                  
                  <div className="flex flex-wrap gap-2 pt-2">
                    {specialty.technologies.map((tech) => (
                      <span
                        key={tech}
                        className="text-xs px-2 py-1 bg-purple-500/10 text-purple-400 rounded border border-purple-500/20"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;